import type { ComponentChildren } from "preact";
import { useId } from "preact/hooks";
import { cx } from "../cx";

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: ComponentChildren;
  description?: ComponentChildren;
  disabled?: boolean;
  class?: string;
}

/** Labelled on/off switch. Space toggles; the whole row is clickable. */
export function Toggle({ checked, onChange, label, description, disabled = false, class: cls }: ToggleProps) {
  const id = useId();
  return (
    <label class={cx("toggle", disabled && "is-disabled", cls)} for={id}>
      <span class="toggle__text">
        <span class="toggle__label">{label}</span>
        {description && <span class="toggle__desc">{description}</span>}
      </span>
      <input
        id={id}
        class="toggle__input"
        type="checkbox"
        role="switch"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.currentTarget.checked)}
        data-nav=""
      />
      <span class="toggle__track" aria-hidden="true">
        <span class="toggle__knob" />
      </span>
    </label>
  );
}
